import personal from './personal'
import personalInner from './personalInner';

export default { ...personal, ...personalInner };
